module.exports = __webpack_public_path__ + "img/home.22593d19.png";